import React, { memo } from 'react';
import { RouteObject, useRoutes, Navigate } from 'react-router-dom';
import Callback from '../pages/callback';
import NotFoundPage from '../pages/404';
import {
  PrivateRoute as privateRoute,
  ActiveCase,
  Settings,
  Landing,
  UserProfile,
} from './app';

const PrivateActiveCase = privateRoute(ActiveCase);
const PrivateSettings = privateRoute(Settings);
const PrivateLanding = privateRoute(Landing);
const PrivateUserProfile = privateRoute(UserProfile);

const routeHandler = (): RouteObject[] => {
  return [
    {
      element: <Navigate to="/app" replace />,
      path: '/',
    },
    {
      element: <PrivateLanding />,
      path: '/app',
    },
    {
      element: <PrivateLanding />,
      path: '/app/landing',
    },

    {
      element: <PrivateUserProfile />,
      path: '/app/profile',
    },

    {
      element: <PrivateActiveCase />,
      path: '/app/activecase',
    },

    {
      element: <PrivateSettings />,
      path: '/app/settings',
    },

    {
      path: '/callback',
      element: <Callback />,
    },

    {
      path: '/404',
      element: <NotFoundPage />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ];
};

const useAppRoutes = () => {
  return useRoutes(routeHandler());
};

const RouterComponent = memo(() => {
  return <>{useAppRoutes()}</>;
});
export default RouterComponent;
